import store from 'src/js/store';
import actions from '../actions';

const redirectToStore = () => {
  store.dispatch(actions.redirectToStore());
};

export default redirectToStore;
